import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * [자동화 요약 > 타임라인] 트리거 타임라인 데이터 조회
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getTriggerTimelineData(params) {
    return axios.post(`${baseUrl}/ams/summary/get-trigger-timeline-data.do`, params);
  },
  /**
   * [자동화 요약 > 상단 카운트 뷰] 장비 대수, 등록 트리거 수, 트리거 성공률, 트리거 실패/부분성공 건수 조회
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getTriggerNodeCountViewData(params) {
    return axios.post(`${baseUrl}/ams/summary/get-trigger-node-count-view-data.do`, params);
  },
  /**
   * [자동화 요약 > 파이차트] 트리거 성공, 부분성공, 실패 건수 조회
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getTrgExecResultFlagCount(params) {
    return axios.post(`${baseUrl}/ams/summary/get-trg-exec-result-flag-count.do`, params);
  },
  /**
   * [자동화 요약 > 컬럼차트] 수행된 트리거, 실패 트리거, 실패 잡 topN 데이터 조회
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getExecResultTopNData(params) {
    return axios.post(`${baseUrl}/ams/summary/get-exec-result-top-n-data.do`, params);
  },
  /**
   * [자동화 요약 > 타임라인] 앞으로 1달동안 수행 예정 트리거 목록 조회
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getScheduledTriggerExecutionList(params) {
    return axios.post(`${baseUrl}/ams/summary/get-scheduled-trigger-execution-list.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/ams/summary.js